import { render, staticRenderFns } from "./jingxueManage.vue?vue&type=template&id=2131c2a4&scoped=true&"
import script from "./jingxueManage.vue?vue&type=script&lang=js&"
export * from "./jingxueManage.vue?vue&type=script&lang=js&"
import style0 from "./jingxueManage.vue?vue&type=style&index=0&id=2131c2a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2131c2a4",
  null
  
)

export default component.exports